import IFrame from './Iframe';

export default {
    IFrame,
};
